import { RootState } from 'store/root-reducer';

export const getWimsStatusInfo = (state: RootState) => state.statistics.wimsStatusInfo;
